<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage stock products</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="productsLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading products...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemProducts"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Action'">
                      <button
                        class="btn btn-info btn-sm"
                        @click="stockProduct(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> Add stock
                      </button>
                    </span>
                    <span v-else-if="props.column.field == 'Dead-Stock'">
                      <button
                        class="btn btn-info btn-sm"
                        @click="deadstockProduct(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> Dead stock
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Product number",
          field: "product_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod number",
          },
        },
        {
          label: "Product name",
          field: "product_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod name",
          },
        },
        {
          label: "Product description",
          field: "product_description",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod description",
          },
        },
        {
          label: "measurement",
          field: "product_measurement",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod measurement",
          },
        },
        {
          label: "Buying price",
          field: "buying_price",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter buying price",
          },
        },
        {
          label: "Selling price",
          field: "selling_price",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter selling price",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
        {
          label: "Dead-Stock",
          field: "Dead-Stock",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadProduct();
  },
  computed: {
    ...mapGetters(["systemProducts"]),
  },
  methods: {
    ...mapActions(["loadProduct", "stockProduct", "deadstockProduct"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/stocks/manageproduct.vue